export default {
  props: {
    selectedOffice: {
      type: [Number, String],
      default() {
        return null;
      },
    },
    dateRange: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
